import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminLogin(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Sign in failed";
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-sidebar flex items-center justify-center px-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-block bg-background rounded-sm px-8 py-6 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)]">
            <Logo className="h-32" />
          </div>
          <div className="text-xs italic text-sidebar-muted mt-4">Administration</div>
        </div>

        <form onSubmit={submit} className="bg-background rounded-sm p-8 space-y-5 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.7)]">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-[0.18em] text-foreground">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm mt-1.5" data-testid="admin-email" autoComplete="email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-[0.18em] text-foreground">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-sm mt-1.5" data-testid="admin-password" autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-sm uppercase tracking-wide" data-testid="admin-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="text-center text-xs italic text-sidebar-muted mt-6">Restricted access · authorised users only</div>
      </div>
    </div>
  );
}
